<div 
  *ngIf="!(itemsDisplayService.itemsLoading$ | async)"
  infiniteScroll
  [scrollOffset]="200"
  [debounceTime]="15"
  [scrollContainer]="scrollContainer"
  [onScrollCallback]="onScrollDown.bind(this)"
  (populateListItems)="onScrollPopulateItems($event)">
  
  <div 
    *ngIf="!items || !items.length" 
    class="text--center padding-md">
    Unfortunately, there are no results for this search.
  </div>

  <div 
    *ngFor="let item of items" 
    class="list-item">
    <div
      *ngIf="!matcherMode" 
      class="list-item_checkbox"
      [ngClass]="{'list-item_checkbox--checked': item.isChecked}"
      (click)="onItemChecked(item, $event)">
    </div>
    <div 
      class="list-item_title"
      (click)="!matcherMode && itemsDisplayService.showItemPanel(item)"
      [innerHTML]="item.article?.title || 'Untitled'">
    </div>
    <div class="list-item_author-box">
      <ng-container *ngIf="!!item.article?.displayedAuthors.length">
        <div
          *ngFor="let author of (item.article?.isFullAuthorsShown ? item.article?.authors : item.article?.displayedAuthors)"
          class="list-item_author" >
          {{ item.import_data?.source === 'janssen_endnote' ? author : (author | formatAuthor) }}
        </div>
      </ng-container>
      <span 
        *ngIf="!!item.article?.nonDisplayedAuthorsCount"
        (click)="toggleShowAuthors(item)"
        class="badge">
        {{ item.article.isFullAuthorsShown ? 'less' : ('&#43; ' + item.article.nonDisplayedAuthorsCount + (item.article.nonDisplayedAuthorsCount === 1 ? ' author' : ' authors')) }}
      </span>
    </div>
    <div class="list-item_journal-box">
        {{ item.article?.journal ? (item.article.journal + ' ') : ''}}{{(item.article?.journal && item.article?.year) ? '| ' : '' }}{{ item.article?.year ? item.article.year : '' }}
    </div>
    <div *ngIf="matcherMode">      
      <span class="badge badge--bold badge--blue" (click)="onMatchClick(item)">Match</span>
      &nbsp;
      <span class="badge" (click)="itemsDisplayService.showItemPanel(item)">View Details</span>
    </div>
  </div>

  <scs-loader *ngIf="(loadingMore$ | async)" class="loader_more-container"></scs-loader>

</div>

<div *ngIf="itemsDisplayService.itemsLoading$ | async" class="loader_overlay">
  <scs-loader class="center-horizontal-vertical"></scs-loader>
</div>